import { Component, Input, OnInit, ViewChild, ElementRef, Renderer2, AfterContentChecked } from '@angular/core';
import { AlertMessageService } from '../../cfet-core';

@Component({
    selector: 'app-alert-success',
    templateUrl: './alert-success.component.html',
    styleUrls: ['./alert-success.component.scss'],
    standalone: false
})
export class AlertSuccessComponent implements OnInit, AfterContentChecked {
  showSuccess: boolean;
  messages = [];
  flag: boolean;
  @Input() msgData: any;
  @ViewChild('closeBtn') closeBtnElement: ElementRef;

  constructor(private alertMessageService: AlertMessageService,
    private renderer: Renderer2) { }

  ngOnInit () {
    this.alertMessageService.showSuccess.subscribe((flag) => {
      if (flag !== null) {
        this.showSuccess = flag;
      }
      if (this.showSuccess) {
        this.flag = true;
      }
    });
    if (!this.msgData) {
      this.alertMessageService.successMessages.subscribe((messages) => {
        this.messages = [];
        if (messages) {
          if (Array.isArray(messages)) {
            this.messages = this.messages.concat(messages);
          } else {
            this.messages.push(messages);
          }
        }
      });
    } else {
      this.messages.push(this.msgData);
    }
  }

  ngAfterContentChecked () {
    if (this.closeBtnElement && this.flag) {
      this.renderer.selectRootElement(this.closeBtnElement.nativeElement).focus();
      this.flag = false;
    }
  }

  toggle (val) {
    this[val] = !this[val];
  }

}
